import React from 'react';
import {useTranslations} from 'next-intl';
import Container from '@/container';
import {Grid, Row, Col} from '@/grid';
import {SectionPaddingTop} from '@/section';
import {H3, PNoMargin} from '@/typography';
import {withBgNeutral200} from '@/hocs/withColors';
import {withMarginBottomZeroToLg} from '@/hocs/withSpacing';
import PictureWrapper from '@/ui/images-wrapper';
import LogosCarousel from '@/ui/logos-carousel';
import {CUSTOMER_LOGOS, LOGO_BASE} from '../customer-logos.config';
import styles from '../../industry-shared/features-section.module.scss';

const Neutral200Section = withBgNeutral200(SectionPaddingTop);
const FeatureCol = withMarginBottomZeroToLg(Col);

/** Grid forwards `children` via createProps; PropTypes-only export omits it from types. */
const FluidGrid = Grid as React.ComponentType<{
  fluid?: boolean;
  className?: string;
  tagName?: string;
  children?: React.ReactNode;
}>;

const CARD_KEYS = ['card1', 'card2', 'card3'] as const;

type CardKey = (typeof CARD_KEYS)[number];

const imgPath = '/static/images/industry-healthcare/';

const FeaturesSection = () => {
  const t = useTranslations('industryHealthcare.features');

  return (
    <Neutral200Section>
      <Container>
        <FluidGrid fluid>
          <Row center="xs" start="md" className={styles['cards-row']}>
            {CARD_KEYS.map((cardKey: CardKey) => (
              <FeatureCol key={cardKey} xs={12} md={4}>
                <article className={styles.card}>
                  <div className={styles.media}>
                    <PictureWrapper
                      imgPath={imgPath}
                      imageUrl={t(`${cardKey}.imageUrl`)}
                      imageTypeFallback="jpg"
                      altImage={t(`${cardKey}.imageAlt`)}
                      className={styles.image}
                      loading="lazy"
                    />
                  </div>
                  <div className={styles.content}>
                    <H3>{t(`${cardKey}.title`)}</H3>
                    <PNoMargin>{t(`${cardKey}.description`)}</PNoMargin>
                  </div>
                </article>
              </FeatureCol>
            ))}
          </Row>
        </FluidGrid>
        <LogosCarousel
          logoBase={LOGO_BASE}
          logos={CUSTOMER_LOGOS}
          ariaLabel={t('customerLogosAriaLabel')}
          fadeColor="#F7F5F1"
          muted
        />
      </Container>
    </Neutral200Section>
  );
};

export default FeaturesSection;
